
import { WrapBanner } from "./styles"

export const Atividades = () => {
    return (
        <WrapBanner>
            <div className="parallax"></div>


            <div className="innertxt">
                <h1>Grade de Atividades e Horário de Funcionamento</h1>
                <p className="p-style">Baixe nossa grade de horários de atividades e saiba  mais sobre o que a Gym Center pode oferecer  Horário de Funcionamento:</p>
                <p>De Segunda à Quinta: De 06h às 22:45h</p>
                <p>Sexta: De 06h às 22h</p>
                <p>Sábado: De 09h às 15h</p>
                <p>Domingos e Feriados: De 09h às 13h</p>

                <button>Clique e baixe a grade</button>
            </div>

        </WrapBanner>
    )
}
